import { BACKEND_URL_PREFIX } from "../utils/const";
import { checkAndUpdateToken } from "./auth";
import {
  NETWORK_REQUEST_SENT,
  LAYOUT_FETCH_COMPLETED,
  LINKS_FETCH_COMPLETED,
} from "./types";
import { buildDefaultHeaders } from "./helper";

export const links = () => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/links`,
    buildDefaultHeaders(getState)
  );

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: LINKS_FETCH_COMPLETED, links: data });
  }
};

export const layout = () => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/company`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: LAYOUT_FETCH_COMPLETED, data });
  }

  dispatch(links());
};
